import moment from "moment/moment";
import React from "react";
import { Modal } from "react-bootstrap";
import './AddPromotionalBannerComponent.css'

const AddPromotionalViewDataModal = ({
  viewDataModal,
  handleCloseViewDataModal,
  bannerAnalyticData,
}) => {
  return (
    <div>
      <Modal
        show={viewDataModal}
        onHide={handleCloseViewDataModal}
        backdrop="static"
        className="edit-group-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>View Data</Modal.Title>
        </Modal.Header>
        <Modal.Body className="popup_body_scroll">
          <div className="table-responsive custom-table-01">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>User Name</th>
                  <th>No. of Views</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {bannerAnalyticData?.map((item,index) => {
                  return (
                    <tr>
                      <td>{index+1}</td>
                      <td>
                        <div className="banner_anay_viwe_center">
                          <span>{item?.Username}</span>
                        </div>
                      </td>

                      <td>
                        <div className="banner_anay_viwe_center">
                          <span>{item?.TotalImpresion}</span>
                        </div>
                      </td>
                      <td>{moment(item?.Date).format("DD/MM/YYYY h:mm:ss a")}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
        <button type="button" className="common_btn btn-secondary" data-bs-dismiss="modal" onClick={handleCloseViewDataModal}>Close</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddPromotionalViewDataModal;
